import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	categoryId: string
}

interface ResponseDataShape {
	expenseNo: number
}

export async function expenseNumberGetApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/expense/number/get"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	return await requester.sendRequest(payload, token)
}
